import { MessagingPage } from './../../pages/employee/messaging/messaging';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController} from 'ionic-angular';

import { SearchPage } from '../../pages/employee/search/search';
import { ProfilePage } from '../../pages/employee/profile/profile'
import { User } from '../../providers/user/user';
import { AvatarProvider } from '../../providers/avatar/avatar';
import { AuthProvider } from '../../providers/auth/auth';
import { RhDashboardPage } from '../../pages/employee/_rh/dashboard/rh-dashboard';
import {NotificationsPage} from "../../pages/employee/notifications/notifications";

/*
 *
 * Generated class for the MobileHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'mobile-header',
  templateUrl: 'mobile-header.html'
})
export class MobileHeaderComponent implements OnInit {

  @Input() inputModel: string;
  @Output() inputModelChange = new EventEmitter<string>();


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public modalCtrl: ModalController,
    private authProvider: AuthProvider,
    private avatarProvider: AvatarProvider) {
      this.avatarString = this.authProvider.getUserAvatar();
  }

  avatarString:string = '';

  ngOnInit() {
    if(this.avatarString == undefined){
      this.avatarProvider.get(this.authProvider.user.avatar_id).subscribe((res) => {
        this.avatarString = this.ab2str(res.data.avatar_content.data)
      })
   }
  }

  onChange() {
    this.inputModelChange.emit(this.inputModel);
  }

  // Decoding image buffer
  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
  }

  goToSearch() {
    this.navCtrl.push(SearchPage, {})
      .then(() => {
      })
  }

  goToNotifications() {
    this.navCtrl.push(NotificationsPage, {})
      .then(() => {
      })
  }

  goToRh() {
    this.navCtrl.push(RhDashboardPage, {})
      .then(() => {
      })
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {userId : this.authProvider.user.user_id}).present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/components/mobile-header/mobile-header.ts